<template>
    <layout class="member-wrapper" theme="white">
        <ul class="member-list">
            <li class="member-item" v-for="member in members" :key="member.id">
<!--                <van-radio :name="member.id" checked-color="#348B35">{{member.name}}</van-radio>-->
                <span>{{member.name}}</span>
                <div class="member-pwd">
                    <van-icon class-prefix="iconfont" name="lock" /><span>{{member.devicePwd}}</span>
                </div>
                <div>
                    <span class="operate-button edit" @click="handleEdit(member)">编辑</span>
                    <span class="operate-button delete" @click="handleDelete(member)">删除</span>
                </div>
            </li>
        </ul>
        <div class="submit-button-wrapper">
            <button class="submit-button" @click="handleAdd" v-if="members.length < 2">新 增</button>
        </div>
        <van-dialog v-model="isShowInputDialog" :title="curId ? '编辑成员': '新增成员'" @confirm="handleSubmit" show-cancel-button>
            <input type="text" v-model="memberForm.name" class="input-member-item" placeholder="请输入成员名称">
            <input type="password" v-model="memberForm.devicePwd" class="input-member-item" placeholder="请输入4-8位设备启动密码">
        </van-dialog>
        <van-dialog
                v-model="isShowDeleteTip"
                title="提示"
                confirmButtonText="删除"
                confirmButtonColor="#D30000"
                @confirm="handleDeleteSubmit"
                show-cancel-button>
            <div class="tip-message">删除成员会丢失成员剩余的使用次数,是否确定删除？</div>
        </van-dialog>
    </layout>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    export default {
        name: "Member",
        data() {
            return {
                isShowInputDialog: false,
                isShowDeleteTip: false,
                curId: null,
                memberForm: {
                    name: '',
                    devicePwd: null
                },
                curMember: null
            }
        },
        computed: {
            ...mapState([
                'members'
            ])
        },
        watch: {
            members(newVal) {
                let curMember = this.findDefaultMember(newVal);
                if (curMember) {
                    this.curMember = curMember.id;
                }
            }
        },
        mounted() {
            let curMember = this.findDefaultMember(this.members);
            if (curMember) {
                this.curMember = curMember.id;
            }
        },
        methods: {
            handleAdd() {
                this.curId = null;
                this.memberForm.devicePwd = '';
                this.memberForm.name = '';
                this.isShowInputDialog = true;
            },
            handleEdit(member) {
                this.curId = member.id;
                this.memberForm.name = member.name;
                this.memberForm.devicePwd = null;
                this.isShowInputDialog = true;
            },
            handleDelete(member) {
                this.isShowDeleteTip = true;
                this.curId = member.id;
            },

            handleSubmit() {
                let params = {
                    name: this.memberForm.name.trim(),
                    devicePwd: this.memberForm.devicePwd ? this.memberForm.devicePwd.trim() : null
                };
                if (!params.name) {
                    this.$toast.fail("成员名不能为空");
                    return;
                }
                if (this.curId) {
                    if (params.devicePwd && (params.devicePwd.length < 4 || params.devicePwd.length > 8)) {
                        this.$toast.fail("设备启动密码必须4-8位");
                        return;
                    }
                    this.netEditMember(params);
                } else {
                    if (!params.devicePwd || params.devicePwd.length < 4 || params.devicePwd.length > 8) {
                        this.$toast.fail("设备启动密码必须4-8位");
                        return;
                    }
                    this.netAddMember(params);
                }
            },

            handleDeleteSubmit() {
                this.netDeleteMember(this.curId);
            },

            handleMemberChanged(name) {
                let curMember = this.findDefaultMember(this.members);
                if (!curMember || curMember.id !== name) {
                    this.netSetDefault(name);
                }
            },

            findDefaultMember(members) {
                return members.find(item => item.isDefault === 1);
            },
            /**
             * 添加成员
             * @param params
             * @returns {Promise<void>}
             */
            async netAddMember(params) {
                const toast = this.$toast.loading({
                    message: '请稍等...',
                    forbidClick: true,
                    duration: 0
                });
                try {
                    await this.$req.addMember(params);
                    this.getMembers();
                }catch (e) {
                    //TODO
                } finally {
                    toast.clear();
                }
            },
            /**
             * 修改成员
             * @param params
             * @returns {Promise<void>}
             */
            async netEditMember(params) {
                const toast = this.$toast.loading({
                    message: '请稍等...',
                    forbidClick: true,
                    duration: 0
                });
                try {
                    await this.$req.updateMember({
                        id: this.curId,
                        ...params
                    });
                    this.getMembers();
                }catch (e) {
                    //TODO
                } finally {
                    toast.clear();
                }
            },

            /**
             * 设置默认成员
             * @param id
             * @returns {Promise<void>}
             */
            async netSetDefault(id) {
                const toast = this.$toast.loading({
                    message: '请稍等...',
                    forbidClick: true,
                    duration: 0
                });
                try {
                    await this.$req.setDefaultMember({id: id});
                    this.getMembers();
                } catch (e) {
                    //TODO
                } finally {
                    toast.clear();
                }
            },

            async netDeleteMember(id) {
                const toast = this.$toast.loading({
                    message: '请稍等...',
                    forbidClick: true,
                    duration: 0
                });
                try {
                    await this.$req.delMember({id: id});
                    this.getMembers();
                }catch (e) {
                    //TODO
                } finally {
                    toast.clear();
                }
            },

            ...mapActions([
                'getMembers'
            ])
        }
    }
</script>

<style scoped>

</style>